import { getCustomPriceRangeValues } from './utils';
import { createGAEvent } from '../../../core/js/utils/analyticsUtils';

/**
* Get the ga event for when a applys a custom price range
* @param {object} state - the application state
* @returns {object} - ga event for custom price range
*/
export function createCustomPriceGAEvent(state) {
    const { priceMin, priceMax } = getCustomPriceRangeValues(state.category);
    const customPriceEventCategory = _.get(state, 'core.pageType', _.get(state, 'core.constants.pageType'));
    const currencyPrefix = _.get(state, 'core.currencyFormattingInfo.currencyPrefix', '');
    const currencySuffix = _.get(state, 'core.currencyFormattingInfo.currencySuffix', '');
    const customPriceEventLabel =
        `custom ${currencyPrefix}${priceMin}${currencySuffix} - ${currencyPrefix}${priceMax}${currencySuffix}`;
    return createGAEvent(customPriceEventCategory, 'filter by price', customPriceEventLabel);
}
